/**
 * 网站右侧
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import ShanklistComponents from '../../../components/shanklistComponents/index';
import HotArticleRank from './hotArticleRank';
import SeriesRank from './seriesRank';
import CheZhan from './chezhan';
import { getHotArticleRank, getSeriesRankList, getCheZhanData } from '../../../services/api';

class Aside extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        rankingData: [],
        seriesRankList: [],
        cheZhanData: [],
        componentOptions: { infoTitle: '最新车展', infoUrl: '' },
    };

    async componentDidMount() {
        // try {
        //     const rankingData = await getHotArticleRank();

        //     this.setState({
        //         rankingData,
        //     });
        // } catch (error) {
        //     console.log(error);
        // }
        try {
            const seriesRankList = await getSeriesRankList();

            this.setState({
                seriesRankList,
            });
        } catch (error) {
            console.log(error);
        }

        try {
            const cheZhanData = await getCheZhanData();

            this.setState({
                cheZhanData,
            });
        } catch (error) {
            console.log(error);
        }
    }
    asideView(asideData) {
        const element = [];

        for (let i = 0, j = asideData.length; i < j; i++) {
            const item = asideData[i];
            const { chip, data, component, componentOptions } = item;

            if (chip.user && chip.user !== '') {
                element.push(
                    <Chip key={i} content={data} {...chip}>
                        {React.createElement(ShanklistComponents[component], { componentOptions })}
                    </Chip>,
                );
            } else {
                element.push(
                    React.createElement(ShanklistComponents[component], {
                        key: i,
                        componentOptions,
                        content: data,
                    }),
                );
            }
        }

        return element;
    }

    render() {
        const { asideData, noAd, asideAd, columnId, hotArticleRank } = this.props.content;
        const { cheZhanData, componentOptions } = this.state;
        const { rankingData, seriesRankList } = this.state;

        const rankData = {
            rankList: hotArticleRank.toplist.rec,
            infoTitle: '热文排行',
            infoUrl: '',
        };
        const seriesRankData = {
            seriesRankList,
            infoTitle: '大家都在看',
            infoUrl: '',
        };

        return (
            <div>
                <div className={styles.aside}>
                    {this.asideView(asideData)}
                    {columnId === '10-586-' && cheZhanData && cheZhanData.length > 0 ? (
                        <CheZhan content={cheZhanData} componentOptions={componentOptions} />
                    ) : (
                        ''
                    )}
                    {rankData && rankData.rankList.length > 0 ? <HotArticleRank content={rankData} /> : ''}
                    {seriesRankList && seriesRankList.length > 0 ? <SeriesRank content={seriesRankData} /> : ''}
                    {noAd ? null : <Ad styleName={styles.ad} content={asideAd} />}
                </div>
            </div>
        );
    }
}

export { Aside };
export default Aside;
